import { render, staticRenderFns } from "./BookingModal.vue?vue&type=template&id=2242e66a&scoped=true"
import script from "./BookingModal.vue?vue&type=script&lang=ts"
export * from "./BookingModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242e66a",
  null
  
)

export default component.exports